import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "content-wrap"
};
const _hoisted_3 = {
  style: {
    "padding": "0 16px"
  }
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
import { computed, onMounted } from 'vue';
import DOMPurify from 'dompurify';
import { processHtmlImages, getServerImage } from '@/utils/images';
export default {
  __name: 'recreationalvehicle',
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup(__props) {
    const props = __props;
    const remark = computed(() => {
      return DOMPurify.sanitize(processHtmlImages(props.dataInfo?.remark));
    });
    const remark_expand = computed(() => {
      return DOMPurify.sanitize(processHtmlImages(props.dataInfo?.remark_expand));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(getServerImage)(__props.dataInfo?.img),
        alt: __props.dataInfo?.name
      }, null, 8, _hoisted_4)]), _createElementVNode("div", {
        innerHTML: remark.value
      }, null, 8, _hoisted_5)]), _createElementVNode("div", {
        innerHTML: remark_expand.value
      }, null, 8, _hoisted_6)]);
    };
  }
};